import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';
import './App.css';

function Marketing() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { language, toggleLanguage } = useLanguage();
  const t = translations[language];

  return (
    <div className="page">
      <header className="topbar">
        <Link to="/" className="brand">
          <img src="/velyntor_logo-removebg-preview.png" alt="Velyntor" className="brand-logo" />
        </Link>
        <div className="brand-center">VELYNTOR</div>
        <button
          className={`menu-toggle ${menuOpen ? 'open' : ''}`}
          aria-label="Öppna meny"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          <span />
          <span />
          <span />
        </button>
        <div className="topbar-right">
          <nav className={`nav ${menuOpen ? 'open' : ''}`}>
            <Link to="/" onClick={() => setMenuOpen(false)}>
              {t.automation}
            </Link>
            <Link to="/marknadsforing" onClick={() => setMenuOpen(false)}>
              {t.marketing}
            </Link>
            <Link to="/webbutveckling" onClick={() => setMenuOpen(false)}>
              {t.webDevelopment}
            </Link>
            <Link to="/om-oss" onClick={() => setMenuOpen(false)}>
              {t.about}
            </Link>
            <Link to="/kontakt" onClick={() => setMenuOpen(false)}>
              {t.contact}
            </Link>
            <Link to="/kontakt" className="ghost-btn mobile-only" onClick={() => setMenuOpen(false)}>
              {t.bookMeeting}
            </Link>
            <button className="language-toggle mobile-only" onClick={toggleLanguage}>
              <img 
                src="https://flagcdn.com/w20/se.png" 
                alt="Svenska" 
                className={`flag-icon ${language === 'sv' ? 'active' : ''}`}
              />
              <span>/</span>
              <img 
                src="https://flagcdn.com/w20/gb.png" 
                alt="English" 
                className={`flag-icon ${language === 'en' ? 'active' : ''}`}
              />
            </button>
          </nav>
          <button className="language-toggle desktop-only" onClick={toggleLanguage}>
            <img 
              src="https://flagcdn.com/w20/se.png" 
              alt="Svenska" 
              className={`flag-icon ${language === 'sv' ? 'active' : ''}`}
            />
            <span>/</span>
            <img 
              src="https://flagcdn.com/w20/gb.png" 
              alt="English" 
              className={`flag-icon ${language === 'en' ? 'active' : ''}`}
            />
          </button>
        </div>
      </header>

      <main>
        <section className="section alt hero marketing-hero">
          <div className="marketing-hero-visual">
            <div className="hero-visual-element hero-visual-1">🚀</div>
            <div className="hero-visual-element hero-visual-2">📈</div>
          </div>
          <div className="hero-text">
            <p className="eyebrow">{t.marketingEyebrow}</p>
            <h1>{t.marketingTitle}</h1>
            <p className="lede">
              {t.marketingText1}
            </p>
            <p className="lede">
              {t.marketingText2}
            </p>
            <p className="lede">
              {t.marketingText3}
            </p>
            <p className="lede">
              {t.marketingText4}
            </p>
          </div>
        </section>

        <section style={{ marginTop: '40px', marginBottom: '40px' }} className="marketing-section">
          <div className="section-heading">
            <div className="section-icon">🤝</div>
            <p className="eyebrow">{t.marketingPartnership}</p>
            <h2>{t.marketingPartnershipTitle}</h2>
            <p className="section-sub">
              {t.marketingPartnershipText1}
            </p>
            <p className="section-sub" style={{ marginTop: '20px' }}>
              {t.marketingPartnershipText2}
            </p>
            <p className="section-sub" style={{ marginTop: '20px' }}>
              {t.marketingPartnershipText3}
            </p>
            <p className="section-sub" style={{ marginTop: '20px' }}>
              {t.marketingPartnershipText4}
            </p>
            <p className="section-sub" style={{ marginTop: '20px' }}>
              {t.marketingPartnershipText5}
            </p>
          </div>
        </section>

        <section className="section marketing-ads">
          <div className="section-heading">
            <div className="section-icon">📢</div>
            <p className="eyebrow">{t.marketingAds}</p>
            <h2>{t.marketingAdsTitle}</h2>
            <p className="section-sub">
              {t.marketingAdsText1}
            </p>
            <p className="section-sub">
              {t.marketingAdsText2}
            </p>
            <div className="cta-actions" style={{ marginTop: '24px', justifyContent: 'center' }}>
              <button className="primary-btn">{t.marketingAdsButton}</button>
            </div>
            <p style={{ textAlign: 'center', marginTop: '12px', color: '#a8b6ff', fontSize: '1.05rem', fontWeight: 600 }}>
              {t.marketingAdsDisclaimer}
            </p>
          </div>
        </section>

        <section className="section alt marketing-philosophy">
          <div className="section-heading">
            <div className="section-icon">🎯</div>
            <p className="eyebrow">{t.marketingPhilosophy}</p>
            <h2>{t.marketingPhilosophyTitle}</h2>
            <p className="section-sub">
              {t.marketingPhilosophyText1}
            </p>
            <p className="section-sub" style={{ marginTop: '16px', fontWeight: '600', color: '#8dc8ff' }}>
              {t.marketingPhilosophyText2}
            </p>
          </div>
        </section>

        <section id="contact" className="section cta">
          <div>
            <p className="eyebrow">{t.contact}</p>
            <h2>{t.marketingCtaTitle}</h2>
            <p className="section-sub">
              {t.marketingCtaSubtitle}
            </p>
          </div>
          <div className="cta-actions">
            <Link to="/kontakt" className="primary-btn" style={{ textDecoration: 'none', display: 'inline-block' }}>{t.bookMeeting}</Link>
            <a href="mailto:info@velyntor.se" className="secondary-btn" style={{ textDecoration: 'none', display: 'inline-block' }}>{t.email}</a>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h4>{t.footerContact}</h4>
            <p style={{ marginTop: '8px' }}>
              <a href="mailto:info@velyntor.se">{t.email}</a>
            </p>
            <p style={{ marginTop: '4px' }}>
              <a href="tel:+46700252952">+46 70 025 29 52</a>
            </p>
            <p style={{ marginTop: '4px' }}>
              <a href="https://linkedin.com/company/techblaze-ab/" target="_blank" rel="noreferrer">
                LinkedIn
              </a>
            </p>
          </div>
          <div className="footer-section">
            <h4>{t.footerPages}</h4>
            <div className="footer-links">
              <Link to="/">{t.automation}</Link>
              <Link to="/marknadsforing">{t.marketing}</Link>
              <Link to="/webbutveckling">{t.webDevelopment}</Link>
              <Link to="/om-oss">{t.about}</Link>
              <Link to="/kontakt">{t.contact}</Link>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div>© {new Date().getFullYear()} Velyntor. {t.footerRights}</div>
        </div>
      </footer>
    </div>
  );
}

export default Marketing;

